import { FaUsers, FaClock, FaStar, FaChartLine } from 'react-icons/fa';

export const BENEFITS = [
    {icon: <FaUsers />, title: "Expert Team", description: "Industry veterans with decades of combined experience."},
    {icon: <FaClock />, title: "Fast Delivery", description: "Agile methodologies ensure rapid project completion."},
    {icon: <FaStar />, title: "Quality First", description:"Commitment to excellence in every solution we deliver."},
    {icon: <FaChartLine />, title: "Proven Results", description:"Track Record of successful transformations."},
];